import React, { useState } from "react";
import axios from "axios";

const testURL = process.env.REACT_APP_TEST_URL;
const productionURL = process.env.REACT_APP_PRODUCTION_URL;
const UpdateStatusModal = ({ isOpen, onClose, ticketId }) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [resolutionStatus, setResolutionStatus] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async () => {
    const payload = {
      TicketId: ticketId,
      CurrentStatus: currentStatus,
      ResolutionStatus: resolutionStatus,
    };

    try {
      await axios.post(productionURL + "/api/ondc/updateIssueInfo", payload, {
        headers: { "Content-Type": "application/json" },
      });
      alert("Issue info updated successfully!");
      onClose();
    } catch (error) {
      console.error("Error updating issue info:", error);
      alert("Failed to update issue info.");
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target.classList.contains("modal-overlay") && onClose()}>
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h2 className="modal-title">Update Issue Info</h2>

        <div className="modal-body">
          <div className="input-group">
            <label>Ticket ID</label>
            <input type="text" value={ticketId} readOnly />
          </div>

          <div className="input-group">
            <label>Current Status</label>
            <input
              type="text"
              value={currentStatus}
              onChange={(e) => setCurrentStatus(e.target.value)}
              placeholder="Enter current status"
            />
          </div>

          <div className="input-group">
            <label>Resolution Status</label>
            <input
              type="text"
              value={resolutionStatus}
              onChange={(e) => setResolutionStatus(e.target.value)}
              placeholder="Enter resolution status"
            />
          </div>
        </div>

        <button className="submit-button" onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

export default UpdateStatusModal;
